import {
    EMPTY_APP,
    FETCH_INDUSTRY_EXPERIENCE_TYPES, FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS, FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE,
    FETCH_LOCATIONS, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_FAILURE,
    FETCH_SKILLS, FETCH_SKILLS_SUCCESS, FETCH_SKILLS_FAILURE,
    FETCH_SPECIALTIES, FETCH_SPECIALTIES_SUCCESS, FETCH_SPECIALTIES_FAILURE
} from './constants';

import Request from 'utils/request';
import { sortObjectsByLabel } from 'utils/utils';
import { PATHS } from 'utils/paths';

export const emptyApp = () => ({
    type: EMPTY_APP
});

const fetchIndustryExperienceTypes = () => ({
    type: FETCH_INDUSTRY_EXPERIENCE_TYPES
});

const fetchIndustryExperienceTypesSuccess = (data) => ({
    type: FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS,
    data
});

const fetchIndustryExperienceTypesFailure = (error) => ({
    type: FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE,
    error
});

const fetchLocations = () => ({
    type: FETCH_LOCATIONS
});

const fetchLocationsSuccess = (data) => ({
    type: FETCH_LOCATIONS_SUCCESS,
    data
});

const fetchLocationsFailure = (error) => ({
    type: FETCH_LOCATIONS_FAILURE,
    error
});

const fetchSkills = () => ({
    type: FETCH_SKILLS
});

const fetchSkillsSuccess = (data) => ({
    type: FETCH_SKILLS_SUCCESS,
    data
});

const fetchSkillsFailure = (error) => ({
    type: FETCH_SKILLS_FAILURE,
    error
});

const fetchSpecialties = () => ({
    type: FETCH_SPECIALTIES
});

const fetchSpecialtiesSuccess = (data) => ({
    type: FETCH_SPECIALTIES_SUCCESS,
    data
});

const fetchSpecialtiesFailure = (error) => ({
    type: FETCH_SPECIALTIES_FAILURE,
    error
});



/**
 *  ASYNC ACTIONS
 */

export const getAllIndustryExperienceTypes = () => (dispatch, getStore) => {
    dispatch(fetchIndustryExperienceTypes());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.enumerations.getAllIndustryExperienceTypes())
        .then((response) => {
            response.data.data.forEach((type) => {
                type.label = type.name;
                type.value = type.id;
            });
            response.data.data.sort(sortObjectsByLabel);
            dispatch(fetchIndustryExperienceTypesSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getAllIndustryExperienceTypes error', error, error.response);
            error.friendlyMessage = 'There was an error getting industry experience types. Please try again.';
            dispatch(fetchIndustryExperienceTypesFailure(error));
            throw error;
        });
};

export const getAllLocations = () => (dispatch, getStore) => {
    dispatch(fetchLocations());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.enumerations.getAllLocations())
        .then((response) => {
            response.data.data.forEach((location) => {
                location.label = location.name;
                location.value = location.id;
            });
            dispatch(fetchLocationsSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getAllLocations error', error, error.response);
            error.friendlyMessage = 'There was an error getting locations. Please try again.';
            dispatch(fetchLocationsFailure(error));
            throw error;
        });
};

export const getAllSkills = () => (dispatch, getStore) => {
    dispatch(fetchSkills());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.enumerations.getAllSkills())
        .then((response) => {
            response.data.data.forEach((skill) => {
                skill.label = skill.name;
                skill.value = skill.id;
            });
            response.data.data.sort(sortObjectsByLabel);
            dispatch(fetchSkillsSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getAllSkills error', error, error.response);
            error.friendlyMessage = 'There was an error getting skills. Please try again.';
            dispatch(fetchSkillsFailure(error));
            throw error;
        });
};

export const getAllSpecialties = () => (dispatch, getStore) => {
    dispatch(fetchSpecialties());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.enumerations.getAllSpecialties())
        .then((response) => {
            response.data.data.forEach((specialty) => {
                specialty.label = specialty.name;
                specialty.value = specialty.id;
            });
            response.data.data.sort(sortObjectsByLabel);
            dispatch(fetchSpecialtiesSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getAllSpecialties error', error, error.response);
            error.friendlyMessage = 'There was an error getting specialties. Please try again.';
            dispatch(fetchSpecialtiesFailure(error));
            throw error;
        });
};

export const uploadFile = (file, url, callback, failureCallback) => (dispatch) => {
    let xhr = new XMLHttpRequest();

    xhr.open("PUT", url, true);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');

    //console.log('file', file);

    // Get the thumbnail elements.
    let progressBarEl = document.getElementById(`progress`),
        progressBarWrapperEl = document.querySelector(`.progress--outer`),
        progressOverlayEl = document.querySelector(`.progress--overlay`),
        progressDoneEl = document.querySelector(`.progress--done`);

    //console.log(progressBarEl);

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            //console.log('progress = ' + progress);
            if(progressBarEl != null) {
                progressBarEl.style.width = progress + '%';
            }
        }
    };
    xhr.upload.onloadstart = function (event) {
        if(progressBarEl != null && progressOverlayEl != null && progressBarWrapperEl != null) {
            progressBarEl.style.width = '0%';
            progressOverlayEl.style.display = 'block';
            progressBarWrapperEl.style.display = 'block';
        }
    };
    xhr.upload.onloadend = function (event) {
        //console.log('progress = 100% done');
        if(callback) {
            callback();
        }

        if(progressBarWrapperEl != null && progressDoneEl != null && progressOverlayEl != null) {
            setTimeout(function () {
                progressBarWrapperEl.style.display = 'none';
                progressDoneEl.style.display = 'block';
            }, 250);
            setTimeout(function () {
                progressOverlayEl.style.display = 'none';
                progressDoneEl.style.display = 'none';
            }, 750);
        }
    };
    xhr.onreadystatechange = function() {
        if(xhr.status === 200) {

        } else {
            let error = new Error(xhr.statusText);
            error.status = xhr.status;
            error.message = xhr.statusText;
            error.friendlyMessage = 'There was an error saving your documentation.';
            console.log('uploadFile error', error, error.response);

            if(failureCallback) {
                failureCallback(error);
            }
        }
    };
    xhr.send(file);
};



// WEBPACK FOOTER //
// ./src/containers/App/store/actions.js